<div class="article-description-editor">
  <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true"
      class="no-field-space">
      <sc-dialog-title>
          {{ 'Beschreibung' | translate: ['erp.ui.article-description-editor.title', translationService.language]}}
      </sc-dialog-title>
      <sc-separator-line></sc-separator-line>
      <sc-scroll-pane>
          <sc-padding>
              <form [formGroup]="formGroup">
                  <sc-flex [vertical]="true" [stretchContent]="true">
                      <mat-form-field appearance="fill">
                          <mat-label>{{ 'Usage' | translate: ['erp.entity.articledescription.usage', translationService.language]}}</mat-label>
                          <input matInput formControlName="usage">
                      </mat-form-field>
                      <sc-content-spacer [vertical]="true"></sc-content-spacer>
                      <sc-dictionary-field [model]="description?.title" [maxlength]="255"
                          defaultLabel="Title" labelDictionaryKey="erp.entity.articledescription.title"
                          (dictionaryChanged)="onTitleChanged($event)" [required]="true">
                      </sc-dictionary-field>
                      <sc-content-spacer [vertical]="true"></sc-content-spacer>
                      <sc-dictionary-text-field [rows]="5" [model]="description?.text" [maxlength]="255"
                          defaultLabel="Text" labelDictionaryKey="erp.entity.articledescription.text"
                          (dictionaryChanged)="onTextChanged($event)">
                      </sc-dictionary-text-field>
                  </sc-flex>
              </form>
          </sc-padding>
      </sc-scroll-pane>
      <sc-separator-line></sc-separator-line>
      <sc-actionbar>
          <sc-content-spacer [grow]="true"></sc-content-spacer>
          <button mat-stroked-button (click)="onClose()">
            {{ 'Abbrechen' | translate: ['erp.ui.article-description-editor.action.cancel', translationService.language]}}
          </button>
          <sc-content-spacer></sc-content-spacer>
          <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled()">
            {{ 'Confirm' | translate: ['erp.ui.article-description-editor.action.confirm', translationService.language]}}
          </button>
      </sc-actionbar>
  </sc-flex>
</div>
